
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uiChangeSkladName } from '../../../actions/ui';
import ReservesApi from '../../../API/warehouse/reserves-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader } from '../../../components/Basic/Table';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import { SKLADS_WAREHOUSE } from '../../../constans';
import ReservesLine from './Line';
import styles from './styles.module.scss';

const FILTER = {
  0: 'check_new',
  1: 'check_penalty',
  2: 'check_archive',
};

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '170px', // 7
  '100px', // 8
  '80px', // 9
  '100px', // 10
  '270px', // 11
  '170px', // 12
  '110px', // 13
  '500px', // 14
];
const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 30 * 24 * 3600000);

  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000);
  return start;
};

const ReservesPage = () => {
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [products, setProducts] = useState({ ids: [], byId: {} });

  const { skladName } = useSelector((store) => store.ui);

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [checkAll, setCheckAll] = useState(false);

  const dispatch = useDispatch();
  const [periodFrom, setPeriodFrom] = useState(CalcMonthAgo());

  const [period, setPeriod] = useState({ start: CalcMonthAgo(), end: CalcFeatureTwoDay() });

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      postings.ids.forEach((item) => {
        map_select[postings.byId[item].posting_number] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setProductsSelect({});
    }
  };

  const [productsSelect, setProductsSelect] = useState({});

  const user = useSelector((store) => store.user);

  const params = useMemo(() => {
    return {
      // search: search.trim(),
      //providerId: provider.id,
      limit: parseInt(show),
      page,
      periodFrom,
      notCollected: true,
      tab: FILTER[tab],
      skladName: skladName.short_name,
    };
  }, [search, show, page, tab, period, skladName]);

  const loadCards = () => {
    ReservesApi.getReserves({ data: params }).then((r) => {
      const byIds = {};
      const id = r.reservedProducts.map((item) => item._id);
      r.reservedProducts.forEach((item) => (byIds[item._id] = item));

      setProducts({ byId: byIds, ids: id });
      setProductsSelect({});
      setCheckAll(false);
      setCountStock([r.stock.check_new, r.stock.check_penalty, r.stock.check_archive]);

      setCount(r.stock.count);
    });

    return () => { };
  };

  const onChangeProduct = async (id, field, value, action = undefined) => {
    await ReservesApi.changeReservedProduct({ data: { reservedProductId: id, field, value, action } }).then((r) => {
      //setPostings({ ...postings, byId: { ...postings.byId, [r.posting.posting_number]: r.posting } });
    });
    loadCards();
  };

  useEffect(() => {
    loadCards();
  }, [params]);

  const onChangeTab = (n) => {
    setTab(n);
  };

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  return (
    <>
      <Content>
        <H1>Проверка резервов</H1>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={isAdmin ? ['Ожидает проверки', 'Штрафы', 'Архив'] : ['Ожидает проверки']}
              isNum={true}
              num={countStock}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
          </Row>

          <Row className={styles.row_input}>
            {Object.keys(productsSelect).length > 0 ? (
              <Row className={styles.row_select}>
                <Row>
                  <Button
                    type={TYPE_BUTTONS.RED}
                    style={{ marginRight: '15px' }}
                    onClick={() => {
                      setCheckAll(false);
                      setPostingsPrint({});
                    }}
                  >
                    Очистить выбор
                  </Button>
                </Row>
              </Row>
            ) : (
              <Input
                value={search}
                onBlur={(v) => setSearch(v)}
                onClickEnter={(v) => setSearch(v)}
                label="Поиск"
                disabled={true}
              />
            )}
          </Row>
          <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>
          <Row spaceBetween={true}>
            <Row style={{ height: '40px' }}>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Город"
                select={skladName}
                list={SKLADS_WAREHOUSE.filter((item) => user.sklads[item.short_name])}
                valueFn={(p) => p.name}
                onSelect={(v) => dispatch(uiChangeSkladName(v))}
                width="200px"
                style={{ marginRight: '15px' }}
              />
            </Row>
            <Row>
              <Column style={{ marginRight: '10px' }}>
                <InputLabel>Начало периода</InputLabel>
                <Row style={{ width: '130px' }}>
                  <DateInput
                    value={periodFrom}
                    className={styles.calendar}
                    onChange={(v) => setPeriodFrom(new Date(v))}
                  />
                </Row>
              </Column>
            </Row>
          </Row>
        </WhiteBlock>
        <Table styles={styles.table}>
          <TableHeader whiteHeader>
            <HeaderTitle width={WIDTH_POSTING[9]} />
            <HeaderTitle width={WIDTH_POSTING[7]} centerText={true}>
              Артикул
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[9]} centerText={true}>
              Номер резерва
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[13]} centerText={true}>
              Адрес
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[11]}>Наименование</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Количество
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
              Разбор полетов
            </HeaderTitle>
          </TableHeader>
          {products.ids.map((id) => {
            return (
              <ReservesLine
                tab={tab}
                isAdmin={isAdmin}
                product={products.byId[id]}
                key={id}
                onChange={onChangeProduct}
                width={WIDTH_POSTING}
              />
            );
          })}
        </Table>
      </Content>
    </>
  );
};

export default ReservesPage;
